import { render, staticRenderFns } from "./VirtualTourStatic.vue?vue&type=template&id=37086d52&scoped=true&"
import script from "./VirtualTourStatic.vue?vue&type=script&lang=js&"
export * from "./VirtualTourStatic.vue?vue&type=script&lang=js&"
import style0 from "./VirtualTourStatic.vue?vue&type=style&index=0&id=37086d52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37086d52",
  null
  
)

export default component.exports